
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/journals/wolters-kluwer/auajruol",
      function () {
        return require("private-next-pages/journals/wolters-kluwer/auajruol.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/journals/wolters-kluwer/auajruol"])
      });
    }
  